/**
 * Download utility for agent messages
 */

/**
 * Downloads an agent conversation as a markdown file
 * @param {Object} conv - Conversation object
 * @param {number} index - Conversation index
 * @param {Function} toastSuccess - Toast notification function
 */
export function downloadMessageAsMarkdown(conv, index, toastSuccess) {
    // Build the message content
    let content = `# Agent Response\n\n`;
    content += `**Timestamp:** ${conv.timestamp.toLocaleString()}\n\n`;
    content += `---\n\n`;

    // Add the final response (this already contains all the text)
    if (conv.finalResponse) {
        content += conv.finalResponse + '\n\n';
    }

    // Add only tool-related content from timeline (skip text items as they're in finalResponse)
    if (conv.timeline && conv.timeline.length > 0) {
        conv.timeline.forEach((item) => {
            if (item.type === 'tool_use') {
                content += `\n\n### Tool: ${item.name}\n`;
                if (item.input) {
                    content += `**Input:**\n\`\`\`json\n${JSON.stringify(item.input, null, 2)}\n\`\`\`\n`;
                }
            } else if (item.type === 'tool_result') {
                content += `\n**Result:**\n${item.preview || item.content || ''}\n`;
            }
        });
    }

    // Create blob and download
    const blob = new Blob([content], { type: 'text/markdown' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `agent-response-${conv.timestamp.getTime()}.md`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);

    // Show toast notification
    if (toastSuccess) {
        toastSuccess('Response downloaded as Markdown!', {
            position: 'bottom-right',
            autoClose: 2000
        });
    }
}

export default { downloadMessageAsMarkdown };
